export const FEDERATION_TOKEN_COOKIE_KEY = "_federationToken";
export const REFERRAL_CODE_COOKIE_KEY = "_ir";
